import type { HTMLProps } from "react";

export const Booklet = (props: HTMLProps<SVGSVGElement>) => {
	return (
		<svg
			{...props}
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				strokeWidth="0.5"
				d="M3.75 11.6991V3.72952L7.75 4.30095V12.2705L3.75 11.6991ZM8.5 13.8157C8.37634 13.8477 8.24406 13.8563 8.10858 13.837L3.10858 13.1227C2.61593 13.0523 2.25 12.6304 2.25 12.1327V3.15302C2.25 2.54447 2.78899 2.07701 3.39142 2.16307L8.39142 2.87736C8.42836 2.88263 8.46459 2.88989 8.5 2.899C8.53541 2.88989 8.57164 2.88263 8.60858 2.87736L13.6086 2.16307C14.211 2.07701 14.75 2.54447 14.75 3.15302V12.1327C14.75 12.6304 14.3841 13.0523 13.8914 13.1227L8.89142 13.837C8.75594 13.8563 8.62366 13.8477 8.5 13.8157ZM9.25 12.2705L13.25 11.6991V3.72952L9.25 4.30095V12.2705Z"
				fill="#0E0E0E"
			/>
		</svg>
	);
};
